import React from 'react';
import { connect } from 'react-redux';
import './index.css';
import { NavigationBar, Responsive } from 'common/components';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { isDesktop } from 'common/utils';

const Footer = ({ path, mapIsOpen }) => {
  /**
   * Requested in AP-1578
   * Don't render nav if user is on a mobile device, and the Map component is showing.
   */

  const userIsOnMobileDevice = !isDesktop();
  if (mapIsOpen && userIsOnMobileDevice) return null;

  // Do not show footer on paths:
  // **/add, **/edit/**, **/detail/**/add
  const parsedPath = path && path.split('/');
  if (
    parsedPath &&
    (parsedPath[2] === 'add' ||
      parsedPath[2] === 'edit' ||
      (parsedPath[2] === 'detail' && parsedPath[4] === 'add'))
  )
    return null;

  return (
    <Responsive.Mobile
      component="div"
      className="agi-footer navbar is-fixed-bottom"
    >
      <NavigationBar className="nav-bar__mobile" />
    </Responsive.Mobile>
  );
};

const mapState = state => ({
  path: get(state, 'router.location.pathname'),
  mapIsOpen: state.field.showMapFlag,
});

Footer.propTypes = {
  path: PropTypes.string,
  mapIsOpen: PropTypes.bool,
};

export default connect(mapState)(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer/index.js